import { JSONSchemaType } from "ajv"
import validateConstant from "../../../constant/validateConstant"
import util from "../../../ts/util"
import { TDaiyoZyomuinTeatePutReq } from "./TDaiyoZyomuinTeate"

export const DaiyoZyomuinTeatePutReqSchema: JSONSchemaType<TDaiyoZyomuinTeatePutReq> =
  {
    type: "object",
    properties: {
      大陽乗務員単価ID: {
        type: "number",
        title: "大陽乗務員単価ID",
        nullable: true,
        errorMessage: util.stringErrorMessage("大陽乗務員単価ID", {
          required: false,
        }),
      },
      荷主請求ID: {
        type: "number",
        title: "荷主請求ID",
        nullable: false,
        errorMessage: util.stringErrorMessage("荷主請求", {
          required: true,
        }),
      },
      乗務員コード: {
        title: "乗務員コード",
        type: "string",
        nullable: false,
        minLength: 1,
        maxLength: validateConstant.LENGTH.社員コード,
        errorMessage: util.stringErrorMessage("乗務員", {
          required: true,
          maxLength: validateConstant.LENGTH.社員コード,
        }),
      },
      車輌ID: {
        title: "車輌ID",
        type: "number",
        nullable: false,
        errorMessage: util.stringErrorMessage("車輌", {
          required: true,
        }),
      },
      距離設定区分コード: {
        title: "距離設定区分コード",
        type: "string",
        nullable: false,
        minLength: 1,
        maxLength: validateConstant.LENGTH.汎用区分コード,
        errorMessage: util.stringErrorMessage("距離設定区分", {
          required: true,
          maxLength: validateConstant.LENGTH.汎用区分コード,
        }),
      },
      大陽社員コード: {
        title: "大陽社員コード",
        type: "string",
        nullable: true,
        maxLength: validateConstant.LENGTH.大陽社員コード,
        errorMessage: util.stringErrorMessage("大陽社員コード", {
          required: false,
          maxLength: validateConstant.LENGTH.大陽社員コード,
        }),
      },
      日当: {
        title: "日当",
        type: "number",
        nullable: false,
        errorMessage: util.stringErrorMessage("日当", {
          required: true,
        }),
      },
      酸素単価: {
        title: "酸素単価",
        type: "number",
        nullable: false,
        errorMessage: util.stringErrorMessage("酸素単価", {
          required: true,
        }),
      },
      窒素単価: {
        title: "窒素単価",
        type: "number",
        nullable: false,
        errorMessage: util.stringErrorMessage("窒素単価", {
          required: true,
        }),
      },
      アルゴン単価: {
        title: "アルゴン単価",
        type: "number",
        nullable: false,
        errorMessage: util.stringErrorMessage("アルゴン単価", {
          required: true,
        }),
      },
      距離単価: {
        title: "距離単価",
        type: "number",
        nullable: false,
        errorMessage: util.stringErrorMessage("距離単価", {
          required: true,
        }),
      },
      荷主品名ID: {
        title: "荷主品名ID",
        type: "number",
        nullable: true,
        errorMessage: util.stringErrorMessage("荷主品名", {
          required: false,
        }),
      },
      更新日時: {
        type: "string",
        nullable: true,
        title: "更新日時",
        errorMessage: util.stringErrorMessage("更新日時", {
          required: true,
        }),
      },
      削除フラグ: {
        type: "number",
        title: "削除フラグ",
        enum: [0, 1],
        errorMessage: util.stringErrorMessage("削除フラグ", {
          required: false,
        }),
      },
    },
    required: [
      "荷主請求ID",
      "乗務員コード",
      "車輌ID",
      "距離設定区分コード",
      "日当",
      "酸素単価",
      "窒素単価",
      "アルゴン単価",
      "距離単価",
      "削除フラグ",
    ],
    errorMessage: {
      required: util.JsonSchemeRequiredErrorMessages([
        ["荷主請求ID", "荷主請求"],
        ["乗務員コード", "乗務員"],
        ["車輌ID", "車輌"],
        ["距離設定区分コード", "距離設定区分"],
        "日当",
        "酸素単価",
        "窒素単価",
        "アルゴン単価",
        "距離単価",
        "削除フラグ",
      ]),
    },
  }
